<span class="badge" [class]="'badge--' + color">{{ label ?? status }}</span>
